var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Captions"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56.562 17.372c-.316-5.255-4.704-9.372-9.989-9.372h-2.573v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-16v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-2.573c-5.286 0-9.674 4.117-9.989 9.372-.593 9.884-.582 19.91.033 29.799.312 5.022 4.335 9.045 9.357 9.357 5.033.313 10.102.469 15.171.469 5.068 0 10.138-.156 15.171-.469 5.022-.312 9.045-4.335 9.357-9.357.616-9.884.627-19.909.035-29.799zm-4.026 29.551c-.188 3.013-2.601 5.426-5.613 5.613-9.902.615-19.944.615-29.846 0-3.013-.188-5.426-2.601-5.613-5.613-.473-7.603-.57-15.286-.317-22.923h41.707c.252 7.64.155 15.323-.318 22.923zm-30.536-30.923c1.104 0 2-.896 2-2v-2h16v2c0 1.104.896 2 2 2s2-.896 2-2v-2h2.573c3.173 0 5.807 2.465 5.996 5.611.047.794.067 1.593.106 2.389h-41.35c.04-.796.059-1.595.106-2.389.189-3.146 2.822-5.611 5.996-5.611h2.573v2c0 1.104.896 2 2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 43,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 33,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 43,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 43,
    r: 3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.172736f900fc6b17aa633d91cca90a0a.svg";
export { ForwardRef as ReactComponent };